import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'a[mcrai-icon-button], button[mcrai-icon-button]',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-icon-button{width:40px;height:40px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;margin:0 2px;cursor:pointer;box-sizing:border-box;border:0;outline:0;text-decoration:none}.mcrai-icon-button .mcrai-icon{font-size:18px}.mcrai-icon-button--disabled{pointer-events:none;cursor:none}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mcrai-icon-button]': 'true'
  }
})
export class IconButtonComponent implements OnInit {

  @Input() set disabled(value: boolean) {
    if (value) {
      this._renderer.addClass(this._elRef.nativeElement, `mcrai-icon-button--disabled`);
    } else {
      this._renderer.removeClass(this._elRef.nativeElement, `mcrai-icon-button--disabled`);
    }
  }

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef,
  ) { }

  ngOnInit() { }

}
